import script from "./user.vue?vue&type=script&setup=true&lang=js"
export * from "./user.vue?vue&type=script&setup=true&lang=js"

import "./user.vue?vue&type=style&index=0&id=19c1d82a&lang=less"
import "./user.vue?vue&type=style&index=1&id=19c1d82a&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/pay.7pa.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c1d82a"]])

export default __exports__